import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../index';
import Button from '../../Button/Button';
import Input from '../../Input/Input';
import Label from '../../InputLabel';
import style from '../Dialog.module.scss';

export default function CreateSupplier({
  handleClose,
  title,
  open,
  buttonTitle,
  saveSupplier,
  initialValues,
}) {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  useEffect(() => {
    setName(initialValues?.name || '');
  }, [initialValues, open]);

  return (
    <Dialog handleClose={handleClose} open={open} title={title}>
      <div className={style.formControl}>
        <Label text={t('Supplier name')} htmlFor='supplier_name' />
        <Input
          placeholder={t('Enter supplier name')}
          value={name}
          name='supplier_name'
          fullWidth
          onChange={(event) => setName(event.target.value)}
        />
      </div>
      <div className={style.buttonSaveBlock}>
        <Button
          disabled={!name.trim()}
          onClick={() => saveSupplier({ name: name.trim() })}
          fillWidth
          size='big'
        >
          {buttonTitle}
        </Button>
      </div>
    </Dialog>
  );
}
